import BannerApi from '@apis/banner/BannerApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { BannerType } from '@models/banner';

const bannerQueries = createQueryKeys('banners', {
    list: (type: BannerType) => ({
        queryKey: [type],
        queryFn: () => BannerApi.getBanners(type),
    }),
});

export default bannerQueries;
